'use client'

import { useDisplayCurrency } from './display-currency'
import { htmlWithDisplayCurrency } from './link'

interface CurrencyCarryingHtmlProps {
    /** Markup already sanitized by the caller: this writes it to the DOM as given. */
    html: string
    className?: string
}

/**
 * Authored HTML copy, written into a `div` with the page's selected display currency
 * carried onto every internal link inside it — the anchors in editorial prose that never
 * pass through `Link`.
 *
 * A client leaf because the selection is a context read. Sanitizing stays with the
 * server-rendered caller, so the sanitizer never ships in the client bundle.
 */
export function CurrencyCarryingHtml({ html, className }: CurrencyCarryingHtmlProps) {
    const selected = useDisplayCurrency()

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: htmlWithDisplayCurrency(html, selected) }}
        />
    )
}
